<template>
<div>
  <div v-if="!disableCollapse" class="row align-items-center" style="cursor: pointer" @click="toggleExpanded">
      <div class="title-chevron fa col-md-auto" :class="{ 'fa-chevron-up': expanded, 'fa-chevron-down' : !expanded }" ></div>
      <div class="title col-md-auto pl-0">{{title}}</div>
      <div class="title-line col" />
      <div class="title-chevron fa col-md-auto" :class="{ 'fa-chevron-up': expanded, 'fa-chevron-down' : !expanded }"></div>
  </div>
  <div v-else class="row align-items-center" >
    <div class="title-line ml-3" style="width: 0.75rem; "></div>
    <div class="title col-md-auto">{{title}}</div>
    <div class="title-line col mr-3" />
  </div>
  <div v-if="expanded" class="row">
    <slot></slot>
  </div>
</div>  
</template>

<script>
export default {
  components: {},
  data() {
    return {
      expanded: this.expandedByDefault
    };
  },
  props: {
    title: {
      type: String,
      required: true
    },
    expandedByDefault: {
      type: Boolean,
      default: false
    },
    disableCollapse: {
      type: Boolean,
      default: false
    }
  },
  methods: {   
    toggleExpanded() {
      if (!this.disableCollapse) 
        this.expanded = !this.expanded;
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 1.15rem;
  margin: .5rem 0;
}

.title-line {
  background-color:rgba(0, 0, 0, 0.125);
  height:1px;
}

.title-chevron {
  color:rgba(0, 0, 0, 0.5);
}
</style>


// WEBPACK FOOTER //
// src/framework/primitives/AmfExpandableArea.vue